import {useEffect, useLayoutEffect, useRef} from 'react'
import {useLocation, matchPath} from 'react-router-dom'

const PDP_ROUTE = '/:locale/p/:productName/:productId.html'

const getPDPParams = (path) => {
    const match = matchPath(path, {path: PDP_ROUTE, exact: false})
    return match?.params || null
}

/**
 * Custom ScrollToTop that prevents scroll reset during PDP swatch navigation.
 * Only preserves scroll when navigating between variants of the SAME product (swatch/colour
 * changes). Navigating to a different product — e.g. via a carousel tile — still scrolls to top.
 */
export default function ScrollToTop() {
    const {pathname} = useLocation()
    const previousPathRef = useRef(null)

    // The app manages scroll explicitly (scroll-to-top on nav, restore-to-product on PLP
    // back). Disable the browser's native scroll restoration so it doesn't re-apply a stale
    // mid-page offset on reload after the async content has grown the page.
    useEffect(() => {
        if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual'
        }
    }, [])

    useLayoutEffect(() => {
        const prevParams = getPDPParams(previousPathRef.current)
        const currParams = getPDPParams(pathname)
        // Swatch navigation: both paths are PDPs and share the same productName slug
        // (only the productId/variant portion changes).
        const isSwatchNavigation = prevParams && currParams && prevParams.productName === currParams.productName

        if (!isSwatchNavigation) {
            queueMicrotask(() => {
                requestAnimationFrame(() => window.scrollTo({top: 0, behavior: 'instant'}))
            })
        }

        previousPathRef.current = pathname
    }, [pathname])

    return null
}
